//this page renders if a worker is not onboarded yet. 
// meaning the worker still has a temporary password and must complete onboarding. 
//Or a worker is coming from a new company and needs to enroll his face. 

import {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Spinner from '../../components/Spinner' 
import {useNavigate} from 'react-router-dom'
import { logoutWorker, resetWorkerUser } from '../../features/workerAuth/workerAuthSlice'



import PasswordStep from '../../components/workerOnboarding/PasswordStep'

import AddressStep from '../../components/workerOnboarding/AdddressStep'
import ProfilePictureStep from '../../components/workerOnboarding/ProfilePictureStep'
import Instructions from '../../components/workerOnboarding/Instructions';
import { toast } from 'react-toastify'
import {onboardWorker} from '../../features/workerAuth/workerAuthSlice'


function WorkerOnboarding (){
    const dispatch = useDispatch()
    const navigate = useNavigate()

    // Redux states
    const { workerUser, isError, isSuccess, isLoading, message } = useSelector(state => state.workerAuth);
    const onboarded = workerUser?.onboarded;
   
    useEffect(() => {
    if (onboarded && isSuccess) {
        toast.success('Onboarding successful!');
        setTimeout(() => {
            dispatch(logoutWorker());
            dispatch(resetWorkerUser());
            navigate('/workerLogin');
        }, 1500); // 1.5 seconds delay for user to see the message
    }

    if (isError) {
        toast.error('Failed to complete onboarding, try again.');
    }
}, [onboarded, isSuccess, isError, message, navigate, dispatch]);


    const [step, setStep] = useState(1);
    const [password, setPassword] = useState("");
    
    const [address, setAddress] = useState({});
    const [sessionId, setSessionId] = useState("");
    const [language, setLanguage] = useState('Eng'); // Default language, Spa for spanish.

    


    /**
     * Change state variable functions to be passed to child components
     * State info is then sent to the backend
     */
    const handleSessionIdChange = (sessionId) => {
       setSessionId(sessionId)
    };

    const handleSetPassword = (password) => {
        setPassword(password)
    };


    const handleSetAddress = (childAddress) => {
        setAddress(childAddress)
    };

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
    };

    /**
     * Updates Worker's details
     * Send data to the backend for processing
     *
     */

    //Submit the data to the backend. 
    const submitData = () => {
        const onboardData = {
            liveness_Session: sessionId,
            address: address,
            password: password,
            language: language,
        };

        dispatch(onboardWorker(onboardData))
    };

    const nextStep = () => {
        if (step < 4) { // Now 4 steps
          setStep(step + 1);
        }
    };


    if(isLoading){
        return <Spinner/>
    }
    
    return(
    <>
        {/* From Redux, get worker name*/}
        <div>
            <h1 className='text-xl font-bold text-center mt-5'>
                {(workerUser?.workerName || '') + ' ' + (workerUser?.workerLastName || '')}
            </h1>
            <p className='text-xl font-normal text-center mb-5'> {step}/4</p>

        </div>

        {
        /* Step 1, verify real person and get worker picture, and sessionID */
        /* Step 2, set password ONLY IF worker is new */
        /* Step 3, ASK USER to reset their password*/
        /* Step 4, Enter mailing address. */
        }
        
        <div>
            {step === 1 &&
                <Instructions language={language} setLanguage={handleLanguageChange} nextStep={nextStep} />}

            {step === 2 &&  
                //Include a language prop for rekognition to use the language for liveness detection.
                <ProfilePictureStep nextStep={nextStep} onSessionIdChange={handleSessionIdChange} language={language} />}

            {step === 3 && 
                <PasswordStep setPassword={handleSetPassword} nextStep={nextStep} />} 

            {step === 4 && 
                <AddressStep setAddress={handleSetAddress} nextStep={submitData} />} 
        </div>
    </>
    )
}

export default WorkerOnboarding;